import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Slurring",
  "description": "",
  "published": "2006-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/slurring/swizec/366"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I'm not sure what sucks more, the play I've seen today or my nanowrimo progress, but whichever it is, it sucks so much it makes me slurr. It would appear that I am suffering from a bit of an annoyance writer's block. See the problem isn't in the inability to write, it isn't even in the lack of ideas or Osiris forbid unwantingness to write. It is pure and simple that whenever I intend on writing some there is something that will prevent it. Be it a good show that's just produced a new episode, computer trouble or hell, going to the tea shop with people rather than alone and thus being unable to write, whatever it is, it's bloody annoying.`}</p>
    <p>{`About the play I mentioned, it was a thing I was forced into going to see with school and as it did two years ago, when I saw the exact same play by the exat same actors, it sucked. I didn't enjoy the story much, nor really the message behind its tale. What I did enjoy, though, was the performance of the main role, it was done very well and it was almost fun to watch, sadly the words were not. Much like Johnny Depp and how he makes some roles simply work only because of him. Oh, not to forget, the play was `}<em parentName="p">{`Look Back In Anger.`}</em></p>
    <p>{`Something very great that I've seen today was the final episode of season one by the great show of `}<a parentName="p" {...{
        "href": "http://www.purepwnage.com/"
      }}>{`Pure Pwnage`}</a>{`, I suggest everyone reading this blog to go and see it and if you haven't already to also watch the rest of the episodes, they're marvelous.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      